import { useContext } from "react";
import { TransactionCreateContext } from "../TransactionCreateProvider";
import TransactionActions from 'bukku/redux/Transaction/actions';
import { useDispatch } from "react-redux";

const {
    changeContactId,
} = TransactionActions;

export const CLOSE_PANEL_ANIMATION_TIME = 200;

/**
 *
 * @returns {() => {}} A function to close the panel and clear contact id
 */
export const useClosePanel = () => {
    const transactionCreateContext = useContext(TransactionCreateContext);
    const { contextAction } = transactionCreateContext;
    const {
        setIsCreatePanelVisible,
        setCreateTransactionType,
        setIsFadingOut,
    } = contextAction;
    const dispatch = useDispatch();

    return () => {
        setIsFadingOut(true);
        setTimeout(() => {
            setIsCreatePanelVisible(false);
            setCreateTransactionType(null);
            dispatch(changeContactId(null));
            setIsFadingOut(false);
        }, CLOSE_PANEL_ANIMATION_TIME);
    };
};
